<template>
  <div :class="`${divClass}__texture`" aria-hidden="true" inert="">
    <div :class="`${divClass}__texture-row`" v-for="item in 50">
      <span v-for="item in 10">Every Job Makes The Stay</span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  divClass: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
    .hc-hero-pri__texture-row, .hc-hero-secondary__texture-row {
      color: #e8ddd99e;
    }
}
</style>
